import { Component, Input, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';

function NgxJsonViewerComponent_section_1_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 9);
} }
function NgxJsonViewerComponent_section_1_span_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 10);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const segment_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(segment_r1.description);
} }
function NgxJsonViewerComponent_section_1_section_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "section", 11);
    ɵngcc0.ɵɵelement(1, "ngx-json-viewer", 12);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const segment_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("json", segment_r1.value)("expanded", ctx_r4.expanded);
} }
const _c0 = function (a1) { return ["segment", a1]; };
const _c1 = function (a1, a2) { return { "segment-main": true, "expandable": a1, "expanded": a2 }; };
function NgxJsonViewerComponent_section_1_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "section", 2);
    ɵngcc0.ɵɵelementStart(1, "section", 3);
    ɵngcc0.ɵɵlistener("click", function NgxJsonViewerComponent_section_1_Template_section_click_1_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r8); const segment_r1 = restoredCtx.$implicit; const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.toggle(segment_r1); });
    ɵngcc0.ɵɵtemplate(2, NgxJsonViewerComponent_section_1_div_2_Template, 1, 0, "div", 4);
    ɵngcc0.ɵɵelementStart(3, "span", 5);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "span", 6);
    ɵngcc0.ɵɵtext(6, ": ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(7, NgxJsonViewerComponent_section_1_span_7_Template, 2, 1, "span", 7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(8, NgxJsonViewerComponent_section_1_section_8_Template, 2, 2, "section", 8);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const segment_r1 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(6, _c0, "segment-type-" + segment_r1.type));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(8, _c1, ctx_r0.isExpandable(segment_r1), segment_r1.expanded));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.isExpandable(segment_r1));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(segment_r1.key);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", !segment_r1.expanded || !ctx_r0.isExpandable(segment_r1));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", segment_r1.expanded && ctx_r0.isExpandable(segment_r1));
} }
class NgxJsonViewerComponent {
    constructor() {
        this.expanded = true;
        /**
         * @deprecated It will be always true and deleted in version 3.0.0
         */
        this.cleanOnChange = true;
        this.segments = [];
    }
    /**
     * @return {?}
     */
    ngOnChanges() {
        if (this.cleanOnChange) {
            this.segments = [];
        }
        if (typeof this.json === 'object') {
            Object.keys(this.json).forEach(key => {
                this.segments.push(this.parseKeyValue(key, this.json[key]));
            });
        }
        else {
            this.segments.push(this.parseKeyValue(`(${typeof this.json})`, this.json));
        }
    }
    /**
     * @param {?} segment
     * @return {?}
     */
    isExpandable(segment) {
        return segment.type === 'object' || segment.type === 'array';
    }
    /**
     * @param {?} segment
     * @return {?}
     */
    toggle(segment) {
        if (this.isExpandable(segment)) {
            segment.expanded = !segment.expanded;
        }
    }
    /**
     * @param {?} key
     * @param {?} value
     * @return {?}
     */
    parseKeyValue(key, value) {
        const /** @type {?} */ segment = {
            key: key,
            value: value,
            type: undefined,
            description: '' + value,
            expanded: this.expanded
        };
        switch (typeof segment.value) {
            case 'number': {
                segment.type = 'number';
                break;
            }
            case 'boolean': {
                segment.type = 'boolean';
                break;
            }
            case 'function': {
                segment.type = 'function';
                break;
            }
            case 'string': {
                segment.type = 'string';
                segment.description = '"' + segment.value + '"';
                break;
            }
            case 'undefined': {
                segment.type = 'undefined';
                segment.description = 'undefined';
                break;
            }
            case 'object': {
                // yea, null is object
                if (segment.value === null) {
                    segment.type = 'null';
                    segment.description = 'null';
                }
                else if (Array.isArray(segment.value)) {
                    segment.type = 'array';
                    segment.description = 'Array[' + segment.value.length + '] ' + JSON.stringify(segment.value);
                }
                else if (segment.value instanceof Date) {
                    segment.type = 'date';
                }
                else {
                    segment.type = 'object';
                    segment.description = 'Object ' + JSON.stringify(segment.value);
                }
                break;
            }
        }
        return segment;
    }
}
NgxJsonViewerComponent.ɵfac = function NgxJsonViewerComponent_Factory(t) { return new (t || NgxJsonViewerComponent)(); };
NgxJsonViewerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NgxJsonViewerComponent, selectors: [["ngx-json-viewer"]], inputs: { expanded: "expanded", cleanOnChange: "cleanOnChange", json: "json" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 2, vars: 1, consts: [[1, "ngx-json-viewer"], [3, "ngClass", 4, "ngFor", "ngForOf"], [3, "ngClass"], [3, "ngClass", "click"], ["class", "toggler", 4, "ngIf"], [1, "segment-key"], [1, "segment-separator"], ["class", "segment-value", 4, "ngIf"], ["class", "children", 4, "ngIf"], [1, "toggler"], [1, "segment-value"], [1, "children"], [3, "json", "expanded"]], template: function NgxJsonViewerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "section", 0);
        ɵngcc0.ɵɵtemplate(1, NgxJsonViewerComponent_section_1_Template, 9, 11, "section", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.segments);
    } }, directives: [ɵngcc1.NgForOf, ɵngcc1.NgClass, ɵngcc1.NgIf, NgxJsonViewerComponent], styles: ["@charset \"UTF-8\";\n    .ngx-json-viewer[_ngcontent-%COMP%] {\n      font-family: monospace;\n      font-size: 1em;\n      width: 100%;\n      height: 100%;\n      overflow: hidden;\n      position: relative; }\n      .ngx-json-viewer[_ngcontent-%COMP%]   .segment[_ngcontent-%COMP%] {\n        padding: 2px;\n        margin: 1px 1px 1px 12px; }\n        .ngx-json-viewer[_ngcontent-%COMP%]   .segment[_ngcontent-%COMP%]   .segment-main[_ngcontent-%COMP%] {\n          word-wrap: break-word; }\n          .ngx-json-viewer[_ngcontent-%COMP%]   .segment[_ngcontent-%COMP%]   .segment-main[_ngcontent-%COMP%]   .toggler[_ngcontent-%COMP%] {\n            position: absolute;\n            margin-left: -14px;\n            margin-top: 3px;\n            font-size: .8em;\n            line-height: 1.2em;\n            vertical-align: middle;\n            color: #787878; }\n            .ngx-json-viewer[_ngcontent-%COMP%]   .segment[_ngcontent-%COMP%]   .segment-main[_ngcontent-%COMP%]   .toggler[_ngcontent-%COMP%]::after {\n              display: inline-block;\n              content: \"\u25BA\";\n              -webkit-transition: -webkit-transform 0.1s ease-in;\n              transition: -webkit-transform 0.1s ease-in;\n              transition: transform 0.1s ease-in;\n              transition: transform 0.1s ease-in, -webkit-transform 0.1s ease-in; }\n          .ngx-json-viewer[_ngcontent-%COMP%]   .segment[_ngcontent-%COMP%]   .segment-main[_ngcontent-%COMP%]   .segment-key[_ngcontent-%COMP%] {\n            color: #4E187C; }\n          .ngx-json-viewer[_ngcontent-%COMP%]   .segment[_ngcontent-%COMP%]   .segment-main[_ngcontent-%COMP%]   .segment-separator[_ngcontent-%COMP%] {\n            color: #999; }\n          .ngx-json-viewer[_ngcontent-%COMP%]   .segment[_ngcontent-%COMP%]   .segment-main[_ngcontent-%COMP%]   .segment-value[_ngcontent-%COMP%] {\n            color: #000; }\n        .ngx-json-viewer[_ngcontent-%COMP%]   .segment[_ngcontent-%COMP%]   .children[_ngcontent-%COMP%] {\n          margin-left: 12px; }\n      .ngx-json-viewer[_ngcontent-%COMP%]   .segment-type-string[_ngcontent-%COMP%]    > .segment-main[_ngcontent-%COMP%]    > .segment-value[_ngcontent-%COMP%] {\n        color: #FF6B6B; }\n      .ngx-json-viewer[_ngcontent-%COMP%]   .segment-type-number[_ngcontent-%COMP%]    > .segment-main[_ngcontent-%COMP%]    > .segment-value[_ngcontent-%COMP%] {\n        color: #009688; }\n      .ngx-json-viewer[_ngcontent-%COMP%]   .segment-type-boolean[_ngcontent-%COMP%]    > .segment-main[_ngcontent-%COMP%]    > .segment-value[_ngcontent-%COMP%] {\n        color: #b938a4; }\n      .ngx-json-viewer[_ngcontent-%COMP%]   .segment-type-date[_ngcontent-%COMP%]    > .segment-main[_ngcontent-%COMP%]    > .segment-value[_ngcontent-%COMP%] {\n        color: #05668D; }\n      .ngx-json-viewer[_ngcontent-%COMP%]   .segment-type-array[_ngcontent-%COMP%]    > .segment-main[_ngcontent-%COMP%]    > .segment-value[_ngcontent-%COMP%] {\n        color: #999; }\n      .ngx-json-viewer[_ngcontent-%COMP%]   .segment-type-object[_ngcontent-%COMP%]    > .segment-main[_ngcontent-%COMP%]    > .segment-value[_ngcontent-%COMP%] {\n        color: #999; }\n      .ngx-json-viewer[_ngcontent-%COMP%]   .segment-type-function[_ngcontent-%COMP%]    > .segment-main[_ngcontent-%COMP%]    > .segment-value[_ngcontent-%COMP%] {\n        color: #999; }\n      .ngx-json-viewer[_ngcontent-%COMP%]   .segment-type-null[_ngcontent-%COMP%]    > .segment-main[_ngcontent-%COMP%]    > .segment-value[_ngcontent-%COMP%] {\n        color: #fff; }\n      .ngx-json-viewer[_ngcontent-%COMP%]   .segment-type-undefined[_ngcontent-%COMP%]    > .segment-main[_ngcontent-%COMP%]    > .segment-value[_ngcontent-%COMP%] {\n        color: #fff; }\n      .ngx-json-viewer[_ngcontent-%COMP%]   .segment-type-null[_ngcontent-%COMP%]    > .segment-main[_ngcontent-%COMP%]    > .segment-value[_ngcontent-%COMP%] {\n        background-color: red; }\n      .ngx-json-viewer[_ngcontent-%COMP%]   .segment-type-undefined[_ngcontent-%COMP%]    > .segment-main[_ngcontent-%COMP%]    > .segment-key[_ngcontent-%COMP%] {\n        color: #999; }\n      .ngx-json-viewer[_ngcontent-%COMP%]   .segment-type-undefined[_ngcontent-%COMP%]    > .segment-main[_ngcontent-%COMP%]    > .segment-value[_ngcontent-%COMP%] {\n        background-color: #999; }\n      .ngx-json-viewer[_ngcontent-%COMP%]   .segment-type-object[_ngcontent-%COMP%]    > .segment-main[_ngcontent-%COMP%], .ngx-json-viewer[_ngcontent-%COMP%]   .segment-type-array[_ngcontent-%COMP%]    > .segment-main[_ngcontent-%COMP%] {\n        white-space: nowrap; }\n      .ngx-json-viewer[_ngcontent-%COMP%]   .expanded[_ngcontent-%COMP%]    > .toggler[_ngcontent-%COMP%]::after {\n        -webkit-transform: rotate(90deg);\n                transform: rotate(90deg); }\n      .ngx-json-viewer[_ngcontent-%COMP%]   .expandable[_ngcontent-%COMP%], .ngx-json-viewer[_ngcontent-%COMP%]   .expandable[_ngcontent-%COMP%]    > .toggler[_ngcontent-%COMP%] {\n        cursor: pointer; }"] });
/**
 * @nocollapse
 */
NgxJsonViewerComponent.ctorParameters = () => [];
NgxJsonViewerComponent.propDecorators = {
    'json': [{ type: Input },],
    'expanded': [{ type: Input },],
    'cleanOnChange': [{ type: Input },],
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxJsonViewerComponent, [{
        type: Component,
        args: [{
                selector: 'ngx-json-viewer',
                template: `
    <section class="ngx-json-viewer">
      <section
        *ngFor="let segment of segments"
        [ngClass]="['segment', 'segment-type-' + segment.type]">
        <section
          (click)="toggle(segment)"
          [ngClass]="{
            'segment-main': true,
            'expandable': isExpandable(segment),
            'expanded': segment.expanded
          }">
          <div *ngIf="isExpandable(segment)" class="toggler"></div>
          <span class="segment-key">{{ segment.key }}</span>
          <span class="segment-separator">: </span>
          <span *ngIf="!segment.expanded || !isExpandable(segment)" class="segment-value">{{ segment.description }}</span>
        </section>
        <section *ngIf="segment.expanded && isExpandable(segment)" class="children">
          <ngx-json-viewer [json]="segment.value" [expanded]="expanded"></ngx-json-viewer>
        </section>
      </section>
    </section>
  `,
                styles: [`
    @charset "UTF-8";
    .ngx-json-viewer {
      font-family: monospace;
      font-size: 1em;
      width: 100%;
      height: 100%;
      overflow: hidden;
      position: relative; }
      .ngx-json-viewer .segment {
        padding: 2px;
        margin: 1px 1px 1px 12px; }
        .ngx-json-viewer .segment .segment-main {
          word-wrap: break-word; }
          .ngx-json-viewer .segment .segment-main .toggler {
            position: absolute;
            margin-left: -14px;
            margin-top: 3px;
            font-size: .8em;
            line-height: 1.2em;
            vertical-align: middle;
            color: #787878; }
            .ngx-json-viewer .segment .segment-main .toggler::after {
              display: inline-block;
              content: "►";
              -webkit-transition: -webkit-transform 0.1s ease-in;
              transition: -webkit-transform 0.1s ease-in;
              transition: transform 0.1s ease-in;
              transition: transform 0.1s ease-in, -webkit-transform 0.1s ease-in; }
          .ngx-json-viewer .segment .segment-main .segment-key {
            color: #4E187C; }
          .ngx-json-viewer .segment .segment-main .segment-separator {
            color: #999; }
          .ngx-json-viewer .segment .segment-main .segment-value {
            color: #000; }
        .ngx-json-viewer .segment .children {
          margin-left: 12px; }
      .ngx-json-viewer .segment-type-string > .segment-main > .segment-value {
        color: #FF6B6B; }
      .ngx-json-viewer .segment-type-number > .segment-main > .segment-value {
        color: #009688; }
      .ngx-json-viewer .segment-type-boolean > .segment-main > .segment-value {
        color: #b938a4; }
      .ngx-json-viewer .segment-type-date > .segment-main > .segment-value {
        color: #05668D; }
      .ngx-json-viewer .segment-type-array > .segment-main > .segment-value {
        color: #999; }
      .ngx-json-viewer .segment-type-object > .segment-main > .segment-value {
        color: #999; }
      .ngx-json-viewer .segment-type-function > .segment-main > .segment-value {
        color: #999; }
      .ngx-json-viewer .segment-type-null > .segment-main > .segment-value {
        color: #fff; }
      .ngx-json-viewer .segment-type-undefined > .segment-main > .segment-value {
        color: #fff; }
      .ngx-json-viewer .segment-type-null > .segment-main > .segment-value {
        background-color: red; }
      .ngx-json-viewer .segment-type-undefined > .segment-main > .segment-key {
        color: #999; }
      .ngx-json-viewer .segment-type-undefined > .segment-main > .segment-value {
        background-color: #999; }
      .ngx-json-viewer .segment-type-object > .segment-main,
      .ngx-json-viewer .segment-type-array > .segment-main {
        white-space: nowrap; }
      .ngx-json-viewer .expanded > .toggler::after {
        -webkit-transform: rotate(90deg);
                transform: rotate(90deg); }
      .ngx-json-viewer .expandable,
      .ngx-json-viewer .expandable > .toggler {
        cursor: pointer; }
  `]
            }]
    }], function () { return []; }, { expanded: [{
            type: Input
        }], cleanOnChange: [{
            type: Input
        }], json: [{
            type: Input
        }] }); })();

class NgxJsonViewerModule {
}
NgxJsonViewerModule.ɵfac = function NgxJsonViewerModule_Factory(t) { return new (t || NgxJsonViewerModule)(); };
NgxJsonViewerModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NgxJsonViewerModule });
NgxJsonViewerModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule
        ]] });
/**
 * @nocollapse
 */
NgxJsonViewerModule.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxJsonViewerModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule
                ],
                declarations: [
                    NgxJsonViewerComponent
                ],
                exports: [
                    NgxJsonViewerComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgxJsonViewerModule, { declarations: function () { return [NgxJsonViewerComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [NgxJsonViewerComponent]; } }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { NgxJsonViewerModule, NgxJsonViewerComponent };

